 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		22: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		22: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"commons","1":"styles","2":"80886e9e5cc3c93c09daf12669334e7fdd72d086","3":"eb5004b32bcc37c23a2d9da63d2c07c368c36b7f","4":"89f2b66160969fcee250a836f7e55b9f012b096e","5":"7e1b41a39d53f78bc1f810d2d782d9a0e771f6bb","6":"afd2e9f745c0d964f7fb8f87fe3cfd23e6e9ddb2","7":"c1cf265a01f345d14ea1f0fa4ad0295a61b17b69","8":"d67daa68dbb7fa5191482c38df4c1ce001f648ce","9":"5ed64baea96c5e28e37e0a3396666fd35d096cd9","10":"ea88be26","11":"7c5ead21e5908f6f25786a511bc70f58e243c1f8","12":"dc594759cb49af661456344cd3ccafd180f5a3e7","13":"6e0d12b2ab3c3a2df6231519f20de4866e9961bf","14":"965e77cbf5d7fd4e7e7e3c8afb64a368e6ced68f","15":"1fe38f8b2c6ac76250641bb343cb2acacb47860c","16":"7723483330c604f709063740994781512be65870","17":"6a4601cf9fc0354f92bde813334f371c96fdc7f1","18":"7880189ec4542ee1989400b4fa6eb530dd978131","19":"a1fda6617e25b9837fea1bf683b2d8ad818416f8","20":"f1fbbf37dbc369d2d0a08906033a0959ac810c1a","21":"fa9fe86e28d2e8d761e1503e2765752a859afffd","24":"component---src-pages-404-js","25":"component---src-pages-about-index-js","26":"component---src-pages-blog-js","27":"component---src-pages-contact-js","28":"component---src-pages-index-js","29":"component---src-pages-notification-js","30":"component---src-pages-portfolio-index-js","31":"component---src-pages-portfolio-map-js","32":"component---src-pages-privacy-js","33":"component---src-pages-terms-js","34":"component---src-pages-under-construction-js","35":"component---src-pages-unsubscribe-js","36":"component---src-templates-blog-article-js","37":"component---src-templates-project-briefing-js","38":"component---src-templates-project-gallery-js","39":"component---src-templates-project-location-js","40":"component---src-templates-project-progress-js","41":"component---src-templates-project-snapshot-js","42":"component---src-templates-project-timeline-js","43":"component---src-templates-project-timeline-post-js","44":"component---src-templates-project-vision-js","45":"e7ff715b","48":"reactPlayerDailyMotion","49":"reactPlayerFacebook","50":"reactPlayerFilePlayer","51":"reactPlayerMixcloud","52":"reactPlayerPreview","53":"reactPlayerSoundCloud","54":"reactPlayerStreamable","55":"reactPlayerTwitch","56":"reactPlayerVidyard","57":"reactPlayerVimeo","58":"reactPlayerWistia","59":"reactPlayerYouTube"}[chunkId]||chunkId) + "-" + {"0":"72d18217e9b81f80cbef","1":"e9d24b1846c7d6eb9685","2":"9ada44da96375f5dd860","3":"6bc207cc6105c284e3af","4":"3847117ea6143d033039","5":"20d4f68777a19324be66","6":"4b1af2e3ed1c93a7fe1d","7":"e4b6e32513f4349b42ac","8":"7642ee180363a76a1edf","9":"64eec3d69d492376a830","10":"64b96de7d5eeb7f5f7f6","11":"41aac96b0eb2bbdffcb1","12":"53a1c9c11ba97743afd6","13":"8836a4d9ed848b102724","14":"f59978bfa0c6e4ed95ff","15":"0330275b9c9f3d8e4289","16":"435b3b730117742ea06b","17":"0fa25e9a3c96ca903a50","18":"fefa1d5af51b15104445","19":"8c86450d52c670e4ddf0","20":"13a361013fce0305dea7","21":"babcfa4b440ae0120e34","24":"5645d2015fc53d925260","25":"f7bec9d1864412607496","26":"dd76bf63fc95ecfe8b08","27":"a1ca832eef0cd46882fd","28":"3d75ec262f2190d2f8c6","29":"25c27e9a1351c30cac40","30":"da2a5c963d198ffb081b","31":"6f853a886564642b8078","32":"2de285c25b0beeb58cd0","33":"5701898f1a2f3f66ca5f","34":"91d8fbb197ff324c1a82","35":"97b766deb8b35d83ed5c","36":"d76f47b0f757f3f8f14d","37":"20d0ab9ac1f1cc460726","38":"fcf3b8bb7788a6c525b6","39":"ec77843e43a5dd4257eb","40":"57ce78ca80ada10bbeee","41":"ab107bbe36c1454f234d","42":"25ac93ccb427338f2169","43":"a70d76cc9065161d2419","44":"6160e6136dbd268b9843","45":"e1fe443378cadbac377a","48":"a04a62b48d8e585b0541","49":"8d199a33e495a781a0b6","50":"3c11d605a54bd1339e51","51":"68525ee7a04bbfd08034","52":"5fd86fbaa4034e779efa","53":"8778ea9fd507ac3e1e20","54":"77b690f07ec743e21270","55":"fa83fa9b2d78c4878925","56":"f9f360902292fda3e4ab","57":"d87dcbfb29236f796d94","58":"09dccb90b5013b48f7d1","59":"f79b8b97186b57d9f548","60":"373fd0932979e3a7834a"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"1":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"commons","1":"styles","2":"80886e9e5cc3c93c09daf12669334e7fdd72d086","3":"eb5004b32bcc37c23a2d9da63d2c07c368c36b7f","4":"89f2b66160969fcee250a836f7e55b9f012b096e","5":"7e1b41a39d53f78bc1f810d2d782d9a0e771f6bb","6":"afd2e9f745c0d964f7fb8f87fe3cfd23e6e9ddb2","7":"c1cf265a01f345d14ea1f0fa4ad0295a61b17b69","8":"d67daa68dbb7fa5191482c38df4c1ce001f648ce","9":"5ed64baea96c5e28e37e0a3396666fd35d096cd9","10":"ea88be26","11":"7c5ead21e5908f6f25786a511bc70f58e243c1f8","12":"dc594759cb49af661456344cd3ccafd180f5a3e7","13":"6e0d12b2ab3c3a2df6231519f20de4866e9961bf","14":"965e77cbf5d7fd4e7e7e3c8afb64a368e6ced68f","15":"1fe38f8b2c6ac76250641bb343cb2acacb47860c","16":"7723483330c604f709063740994781512be65870","17":"6a4601cf9fc0354f92bde813334f371c96fdc7f1","18":"7880189ec4542ee1989400b4fa6eb530dd978131","19":"a1fda6617e25b9837fea1bf683b2d8ad818416f8","20":"f1fbbf37dbc369d2d0a08906033a0959ac810c1a","21":"fa9fe86e28d2e8d761e1503e2765752a859afffd","24":"component---src-pages-404-js","25":"component---src-pages-about-index-js","26":"component---src-pages-blog-js","27":"component---src-pages-contact-js","28":"component---src-pages-index-js","29":"component---src-pages-notification-js","30":"component---src-pages-portfolio-index-js","31":"component---src-pages-portfolio-map-js","32":"component---src-pages-privacy-js","33":"component---src-pages-terms-js","34":"component---src-pages-under-construction-js","35":"component---src-pages-unsubscribe-js","36":"component---src-templates-blog-article-js","37":"component---src-templates-project-briefing-js","38":"component---src-templates-project-gallery-js","39":"component---src-templates-project-location-js","40":"component---src-templates-project-progress-js","41":"component---src-templates-project-snapshot-js","42":"component---src-templates-project-timeline-js","43":"component---src-templates-project-timeline-post-js","44":"component---src-templates-project-vision-js","45":"e7ff715b","48":"reactPlayerDailyMotion","49":"reactPlayerFacebook","50":"reactPlayerFilePlayer","51":"reactPlayerMixcloud","52":"reactPlayerPreview","53":"reactPlayerSoundCloud","54":"reactPlayerStreamable","55":"reactPlayerTwitch","56":"reactPlayerVidyard","57":"reactPlayerVimeo","58":"reactPlayerWistia","59":"reactPlayerYouTube"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"8ae5fd9e8af0cfc3a197","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"31d6cfe0d16ae931b73c","55":"31d6cfe0d16ae931b73c","56":"31d6cfe0d16ae931b73c","57":"31d6cfe0d16ae931b73c","58":"31d6cfe0d16ae931b73c","59":"31d6cfe0d16ae931b73c","60":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
